import { render, staticRenderFns } from "./compare_versions_dropdown.vue?vue&type=template&id=9f12ddfc"
import script from "./compare_versions_dropdown.vue?vue&type=script&lang=js"
export * from "./compare_versions_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports